import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const InfluentFlowIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg width="50px" height="44px" viewBox="0 0 50 44" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Group" transform="translate(14, 11)" fill={color ?? token.colorBorder} fillRule="nonzero">
        <path
          d="M22.4340663,10.1343375 L12.8668675,0.56599891 C12.1122892,-0.188666303 10.8884812,-0.188666303 10.1339029,0.56599891 C9.37932461,1.32066412 9.37932461,2.54461316 10.1339029,3.29927837 L18.3337362,11.5000188 L10.1339029,19.7007216 C9.37932461,20.4553868 9.37932461,21.6793359 10.1339029,22.4340011 C10.8884812,23.1886663 12.1122892,23.1886663 12.8668675,22.4340011 L22.4340663,12.8657001 C23.1886446,12.1129141 23.1886446,10.8890027 22.4340663,10.1343375 Z M10.9306089,9.55493019 L3.33506952,1.54861594 C2.57184773,0.74512807 1.33563813,0.74512807 0.572416343,1.54861594 C-0.190805448,2.35210381 -0.190805448,3.6555447 0.572416343,4.46000977 L6.78713645,11.0106271 L0.572416343,17.5612444 C-0.190805448,18.3647699 -0.190805448,19.6691128 0.572416343,20.4726383 C1.33563813,21.2761637 2.57184773,21.2761637 3.33506952,20.4726383 L10.9306089,12.466324 C11.6938307,11.6628361 11.6938307,10.3593953 10.9306089,9.55493019 Z"
          id="Shape"
        ></path>
      </g>
    </svg>
  );
};

export default InfluentFlowIcon;
